// Static SEO data: state agency directory, glossary, labels.
// Regulatory notes mirror the RegNav KB / analyzer state notes — anything uncertain says "verify".

const STATES_SEO = [
  {
    name: "Rajasthan", slug: "rajasthan",
    stu: "RVPN", stuFull: "Rajasthan Rajya Vidyut Prasaran Nigam Ltd (RVPN)",
    discoms: "JVVNL (Jaipur), AVVNL (Ajmer), JdVVNL (Jodhpur)",
    nodal: "RRECL", nodalFull: "Rajasthan Renewable Energy Corporation Ltd (RRECL)",
    erc: "RERC", ercFull: "Rajasthan Electricity Regulatory Commission (RERC)",
    ceig: "Electrical Inspectorate Department, Government of Rajasthan (Jaipur)",
    nmCapKw: 1000,
    oa: "100 kW open-access threshold per the central GEOA Rules 2022",
    banking: "RERC GEOA Regulations 2025: banking with 8% deduction in kind, 30% cap",
    extra: "Strongest solar resource in India; new Feb-2026 RVPN connectivity procedure is in transition — verify the current process with RVPN",
    land: "Rajasthan's solar policy provides streamlined land-conversion routes and solar-park allotments via RRECL — verify current district-level rules with the collector's office",
  },
  {
    name: "Gujarat", slug: "gujarat",
    stu: "GETCO", stuFull: "Gujarat Energy Transmission Corporation Ltd (GETCO)",
    discoms: "UGVCL, MGVCL, DGVCL, PGVCL (under GUVNL); Torrent Power in licensed areas",
    nodal: "GEDA", nodalFull: "Gujarat Energy Development Agency (GEDA)",
    erc: "GERC", ercFull: "Gujarat Electricity Regulatory Commission (GERC)",
    ceig: "Office of the Chief Electrical Inspector, Government of Gujarat (Gandhinagar)",
    nmCapKw: 1000,
    oa: "Historically open-access-friendly for captive projects; 100 kW GEOA threshold applies",
    banking: "Banking per GERC orders — verify the currently applicable GEOA regulation",
    extra: "Draft GERC DRES Regulations 2026 propose net billing and virtual net metering — track the final notification",
    land: "Gujarat provides NA-exemption and government-wasteland allotment routes for solar under state policy — verify with the district collector and GEDA",
  },
  {
    name: "Maharashtra", slug: "maharashtra",
    stu: "MSETCL", stuFull: "Maharashtra State Electricity Transmission Co. Ltd (MSETCL / Mahatransco)",
    discoms: "MSEDCL statewide; BEST, Adani Electricity and Tata Power in Mumbai",
    nodal: "MEDA", nodalFull: "Maharashtra Energy Development Agency (MEDA)",
    erc: "MERC", ercFull: "Maharashtra Electricity Regulatory Commission (MERC)",
    ceig: "Chief Electrical Inspector, Industries, Energy & Labour Department (Mumbai)",
    nmCapKw: 5000,
    oa: "MSEDCL is known for aggressive cross-subsidy-surcharge and additional-surcharge positions — model charges carefully",
    banking: "Banking per MERC orders; net metering and open access simultaneously allowed (MERC 2025)",
    extra: "Grid Support Charge of ₹1.40/unit applies to net metering above 10 kW; the MSEDCL portal caps rooftop applications at past-12-month consumption",
    land: "Non-agricultural (NA) conversion via the district collector; MIDC land follows separate allotment rules — verify current requirements",
  },
  {
    name: "Uttar Pradesh", slug: "uttar-pradesh",
    stu: "UPPTCL", stuFull: "Uttar Pradesh Power Transmission Corporation Ltd (UPPTCL)",
    discoms: "PuVVNL, MVVNL, PVVNL, DVVNL and KESCO (under UPPCL)",
    nodal: "UPNEDA", nodalFull: "Uttar Pradesh New & Renewable Energy Development Agency (UPNEDA)",
    erc: "UPERC", ercFull: "Uttar Pradesh Electricity Regulatory Commission (UPERC)",
    ceig: "Directorate of Electrical Safety, Government of Uttar Pradesh (Lucknow)",
    nmCapKw: 2000,
    oa: "UP historically applied a 1 MW open-access threshold — a live dispute versus the central 100 kW GEOA rule; verify current practice",
    banking: "Banking is restrictive, with peak/off-peak withdrawal limits — verify the applicable UPERC order",
    extra: "UP Solar Policy 2022 grants 100% stamp-duty exemption for solar projects",
    land: "UP Solar Policy 2022 eases land-use conversion for solar; bundelkhand solar-park land via UPNEDA — verify district-level process",
  },
  {
    name: "Madhya Pradesh", slug: "madhya-pradesh",
    stu: "MPPTCL", stuFull: "Madhya Pradesh Power Transmission Co. Ltd (MPPTCL)",
    discoms: "MPPKVVCL East (Jabalpur), West (Indore) and Central (Bhopal) discoms",
    nodal: "MPUVN", nodalFull: "Madhya Pradesh Urja Vikas Nigam Ltd (MPUVN)",
    erc: "MPERC", ercFull: "Madhya Pradesh Electricity Regulatory Commission (MPERC)",
    ceig: "Office of the Electrical Inspector, Government of Madhya Pradesh (Bhopal)",
    nmCapKw: 500,
    oa: "100 kW GEOA threshold; RE Policy 2025 gives a 50% wheeling-charge waiver for 5 years",
    banking: "Banking in kind at 8% (MPERC GEOA Charges & Banking Regulations 2023)",
    extra: "No open-access + net-metering overlap allowed; group/virtual net metering up to 1 MW by arrangement",
    land: "MP RE Policy 2025 supports revenue-land allotment for RE parks via MPUVN — verify current allotment terms",
  },
  {
    name: "Chhattisgarh", slug: "chhattisgarh",
    stu: "CSPTCL", stuFull: "Chhattisgarh State Power Transmission Co. Ltd (CSPTCL)",
    discoms: "CSPDCL (Chhattisgarh State Power Distribution Co. Ltd)",
    nodal: "CREDA", nodalFull: "Chhattisgarh State Renewable Energy Development Agency (CREDA)",
    erc: "CSERC", ercFull: "Chhattisgarh State Electricity Regulatory Commission (CSERC)",
    ceig: "Office of the Chief Electrical Inspector, Government of Chhattisgarh (Raipur)",
    nmCapKw: 500,
    oa: "~6% energy-loss charge in kind plus 50% CSS; additional surcharge waived for on-premises captive solar",
    banking: "30% in-kind charge on peak-hour (5–11 pm) drawal of banked solar energy (Feb-2026 order)",
    extra: "Virtual net metering enabled Nov-2025; a 40% distribution-transformer cap applies to rooftop solar",
    land: "Land conversion via district administration; CREDA facilitates for RE projects — verify current process",
  },
  {
    name: "Andhra Pradesh", slug: "andhra-pradesh",
    stu: "APTRANSCO", stuFull: "Transmission Corporation of Andhra Pradesh Ltd (APTRANSCO)",
    discoms: "APSPDCL, APEPDCL, APCPDCL",
    nodal: "NREDCAP", nodalFull: "New & Renewable Energy Development Corporation of Andhra Pradesh (NREDCAP)",
    erc: "APERC", ercFull: "Andhra Pradesh Electricity Regulatory Commission (APERC)",
    ceig: "Chief Electrical Inspectorate, Government of Andhra Pradesh (Vijayawada)",
    nmCapKw: 1000,
    oa: "APERC GEOA Regulation 3/2024 for ≥100 kW; ICE Policy 2024 gives eligible new projects a 10-year transmission/wheeling/CSS exemption",
    banking: "Banking up to 30% of monthly consumption at 8% in kind; unutilized energy paid at 75% of the last SECI rate",
    extra: "No network charges on rooftop net metering (unlike Tamil Nadu)",
    land: "AP allots land in notified RE parks via NREDCAP/APSPCL — verify current park-level terms",
  },
  {
    name: "Karnataka", slug: "karnataka",
    stu: "KPTCL", stuFull: "Karnataka Power Transmission Corporation Ltd (KPTCL)",
    discoms: "BESCOM, MESCOM, CESC Mysore, HESCOM, GESCOM",
    nodal: "KREDL", nodalFull: "Karnataka Renewable Energy Development Ltd (KREDL)",
    erc: "KERC", ercFull: "Karnataka Electricity Regulatory Commission (KERC)",
    ceig: "Department of Electrical Inspectorate, Government of Karnataka (Bengaluru)",
    nmCapKw: 1000,
    oa: "LEGAL DIVERGENCE — the Karnataka High Court struck down the central GEOA Rules (Dec-2024); the state runs on its own KERC 2025 open-access regulations",
    banking: "KERC Open Access Regulations 2025: banking at 8% in kind",
    extra: "Rooftop systems below 1 MW are exempt from CEIG clearance; virtual/group net metering live since Jul-2025",
    land: "Karnataka land-conversion (Section 95, KLR Act) via deputy commissioner; KREDL solar-park land available — verify current process",
  },
  {
    name: "Tamil Nadu", slug: "tamil-nadu",
    stu: "TANTRANSCO", stuFull: "Tamil Nadu Transmission Corporation Ltd (TANTRANSCO)",
    discoms: "TANGEDCO (TNPDCL)",
    nodal: "TEDA", nodalFull: "Tamil Nadu Energy Development Agency (TEDA)",
    erc: "TNERC", ercFull: "Tamil Nadu Electricity Regulatory Commission (TNERC)",
    ceig: "Chief Electrical Inspectorate, Government of Tamil Nadu (Chennai)",
    nmCapKw: 1000,
    oa: "TNERC GEOA 2025 for ≥100 kW; additional surcharge ₹0.54/kWh",
    banking: "MONTHLY banking cycle only (annual banking abolished Oct-2025), 8% in kind",
    extra: "Network charges apply on net metering (HT ₹1.04/unit) — struck down for captive behind-the-meter industrial users by the Madras High Court, refunds pending",
    land: "Tamil Nadu land conversion via district revenue offices; SIPCOT parks follow separate rules — verify current requirements",
  },
  {
    name: "Haryana", slug: "haryana",
    stu: "HVPNL", stuFull: "Haryana Vidyut Prasaran Nigam Ltd (HVPNL)",
    discoms: "UHBVN (north), DHBVN (south)",
    nodal: "HAREDA", nodalFull: "Haryana Renewable Energy Development Agency (HAREDA / DNRE)",
    erc: "HERC", ercFull: "Haryana Electricity Regulatory Commission (HERC)",
    ceig: "Chief Electrical Inspector, Government of Haryana (Panchkula)",
    nmCapKw: 500,
    oa: "HERC GEOA 2023: 100 kW threshold, with aggregation allowed within the same discom division",
    banking: "Annual-settlement banking with cross-subsidy surcharge waived till 2028 (Haryana Solar Policy 2023)",
    extra: "Utility-scale solar is exempt from CLU (change of land use); a 10-year electricity-duty waiver applies",
    land: "Utility-scale solar exempt from CLU under the Solar Policy 2023 — verify parcel-specific applicability with the town & country planning department",
  },
  {
    name: "Punjab", slug: "punjab",
    stu: "PSTCL", stuFull: "Punjab State Transmission Corporation Ltd (PSTCL)",
    discoms: "PSPCL (Punjab State Power Corporation Ltd)",
    nodal: "PEDA", nodalFull: "Punjab Energy Development Agency (PEDA)",
    erc: "PSERC", ercFull: "Punjab State Electricity Regulatory Commission (PSERC)",
    ceig: "Chief Electrical Inspector, Government of Punjab (Chandigarh)",
    nmCapKw: 500,
    oa: "100 kW threshold (not explicit in the Punjab regulations text — verify with PSERC/PSPCL)",
    banking: "Month-to-month carry-forward only (PSPCL procedure Sep-2025); 125% penal charges on over-drawal",
    extra: "The 3rd Amendment (Apr-2026) adds group and virtual net metering and RESCO ownership models",
    land: "Punjab land conversion via district administration; PEDA facilitates RE projects — verify current process",
  },
];

const GLOSSARY_SEO = {
  CTU: "Central Transmission Utility — the national interstate grid operator (CTUIL). Large projects selling across state lines connect here.",
  CTUIL: "Central Transmission Utility of India Ltd — the nodal agency for national-grid (ISTS) connectivity applications.",
  STU: "State Transmission Utility — your state's transmission network (e.g., MSETCL in Maharashtra, RVPN in Rajasthan). Power stays within the state.",
  ISTS: "Inter-State Transmission System — the national grid that carries power across state borders.",
  InSTS: "Intra-State Transmission System — the state-level grid operated by the STU.",
  GNA: "General Network Access — the CTUIL application that gives your project the right to use the national grid. It replaced the older LTA/MTOA regime.",
  "T-GNA": "Temporary General Network Access — short-duration grid access granted via the RLDC/NLDC, typically for merchant or short-term sales.",
  LTA: "Long-Term Access — the pre-2022 regime for long-duration interstate transmission rights, replaced by GNA under the CERC Connectivity & GNA Regulations 2022.",
  PTCC: "Power & Telecommunication Coordination Committee — the (legacy) clearance confirming a power line won't interfere with telecom infrastructure. Abolished by the Ministry of Power for new lines w.e.f. 01-Jul-2026; CEA substitute guidelines awaited.",
  NOCAS: "AAI's No Objection Certificate Application System — the online portal for height clearance near airports.",
  AAI: "Airports Authority of India — issues height NOCs for structures near airports via NOCAS.",
  CEIG: "Chief Electrical Inspector to Government — the state safety authority that approves electrical drawings, inspects the installation, and permits charging.",
  RoW: "Right of Way — the legal process (and compensation framework) for placing towers and lines over land you don't own.",
  SLDC: "State Load Despatch Centre — the state grid operator that coordinates first-time charging and synchronization.",
  RLDC: "Regional Load Despatch Centre — the regional grid operator for ISTS-connected projects.",
  NSWS: "National Single Window System — the central government portal where Section 68/164 applications are filed.",
  CEA: "Central Electricity Authority — the technical body that scrutinises applications before Ministry of Power approval.",
  MoP: "Ministry of Power — the central ministry that grants Section 68 and Section 164 approvals.",
  MNRE: "Ministry of New & Renewable Energy — the central ministry for renewable energy policy, schemes and ALMM.",
  CERC: "Central Electricity Regulatory Commission — the central regulator for interstate transmission, tariffs and grid access.",
  SERC: "State Electricity Regulatory Commission — each state's power regulator (e.g., MERC, RERC, GERC), setting open-access, banking and net-metering rules.",
  SPCB: "State Pollution Control Board — issues consent to establish/operate (solar PV is exempt since Nov-2024).",
  CTE: "Consent to Establish — the pollution-control-board approval needed before construction of listed industries.",
  CTO: "Consent to Operate — the pollution-control-board approval needed before operations begin.",
  CGWA: "Central Ground Water Authority — grants NOCs for groundwater drawal, relevant to construction and plant water use.",
  NHAI: "National Highways Authority of India — grants permission for transmission-line crossings over national highways.",
  NBWL: "National Board for Wildlife — clears projects inside or near protected areas.",
  MoEFCC: "Ministry of Environment, Forest & Climate Change — grants forest and wildlife clearances.",
  PARIVESH: "The MoEFCC online portal for forest, wildlife and environment clearances.",
  "FC Act": "Forest (Conservation) Act 1980 — the statute requiring central approval before forest land is used for non-forest purposes.",
  BESS: "Battery Energy Storage System — grid-scale batteries, standalone or paired with solar/wind.",
  EPC: "Engineering, Procurement & Construction — the contractor who builds the plant.",
  IPP: "Independent Power Producer — a company that builds and owns power plants to sell electricity.",
  PPA: "Power Purchase Agreement — the long-term contract to sell a project's power.",
  COD: "Commercial Operation Date — the date a project is declared commercially operational, triggering PPA obligations.",
  ALMM: "Approved List of Models & Manufacturers — MNRE's list of approved solar modules (and cells) mandatory for most Indian projects.",
  SECI: "Solar Energy Corporation of India — the central agency that runs renewable energy tenders.",
  discom: "Distribution company — the local utility that supplies electricity to end consumers.",
  GEOA: "Green Energy Open Access — the 2022 central rules (and state regulations) allowing consumers ≥100 kW to buy green power over the grid.",
  GOAR: "Green Open Access Registry (greenopenaccess.in) — the national portal where GEOA applications are registered.",
  CSS: "Cross-Subsidy Surcharge — a per-unit charge on open-access consumers compensating the discom for lost cross-subsidy.",
  "Additional Surcharge": "A per-unit open-access charge compensating the discom for stranded power-purchase commitments.",
  "Open access": "The right of large consumers (≥100 kW under GEOA) to buy power from suppliers other than their discom, delivered over the grid.",
  Banking: "Storing surplus green energy with the grid and withdrawing it later, per state-specific banking rules and charges.",
  Wheeling: "Transporting power over transmission/distribution networks from a generator to a consumer, for a wheeling charge.",
  "Net metering": "A billing arrangement where rooftop-solar exports offset imports, subject to state capacity caps.",
  Captive: "A project where consumers hold ≥26% equity and consume ≥51% of generation (Electricity Rules 2005) — exempt from CSS/additional surcharge.",
  "Group captive": "A captive structure where multiple consumers jointly hold the ≥26% equity and consume ≥51% of generation.",
  "First-time charging": "The SLDC/RLDC-supervised first energisation of a new plant or line, after CEIG approval and grid-code compliance.",
  "Grid Code": "The technical rules (CEA/IEGC and state codes) a plant must meet for protection, telemetry and grid connection.",
  REC: "Renewable Energy Certificate — a tradable certificate representing the green attribute of 1 MWh of renewable energy.",
  DCR: "Domestic Content Requirement — tenders/schemes requiring Indian-made modules or cells.",
  "Section 68": "Section 68, Electricity Act 2003 — prior Central/State Government approval to install an overhead transmission line.",
  "Section 164": "Section 164, Electricity Act 2003 — confers Telegraph-Act powers on a licensee to place lines over private land with legal backing.",
};

// Condition-field → human phrasing for "when is this required"
const CONDITION_LABELS = {
  project_type: (vals, L) => `Project type: ${vals.map((v) => L[v] || v).join(" / ")}`,
  connectivity: (vals) => `Connectivity level: ${vals.map((v) => ({ ctu: "CTU (ISTS national grid)", stu: "STU (intra-state)", discom: "Discom (distribution)", captive: "Captive behind-the-meter" }[v] || v)).join(" / ")}`,
  business_model: (vals) => `Business model: ${vals.map((v) => ({ captive: "captive (own use)", third_party: "third-party PPA", merchant: "merchant", tender: "regulated tender" }[v] || v)).join(" / ")}`,
  land_type: (vals) => `Land type: ${vals.join(" / ")}`,
  voltage_kv: (vals) => `Voltage level: ${vals.join(" / ")} kV`,
  state: (vals) => `State: ${vals.join(", ")}`,
  forest_land: () => "Site or route involves notified forest land",
  protected_area: () => "Inside or near a protected area / wildlife sanctuary",
  crosses_nh: () => "Route crosses a National Highway",
  crosses_sh: () => "Route crosses a State Highway",
  crosses_railway: () => "Route crosses a railway track",
  crosses_water: () => "Route crosses a water body / canal / river",
  airport_zone: () => "Within ~20 km of an airport (NOCAS zone)",
  defence_nearby: () => "Near a defence establishment",
  crosses_tl: () => "Route crosses existing transmission lines",
  dedicated_line: () => "A dedicated evacuation line is being built",
  bess_included: () => "Battery energy storage (BESS) is included",
};

const PROJECT_TYPE_LABELS = {
  solar_ground: "Solar PV (ground-mounted)",
  solar_rooftop: "Solar PV (rooftop)",
  wind: "Wind",
  hybrid: "Hybrid (solar + wind)",
  bess: "Standalone BESS",
  transmission_line: "Transmission line",
  green_procurement: "Green power procurement",
};

const PHASES = [
  { key: "pre_development", code: "R1", label: "Pre-development approvals" },
  { key: "land_site", code: "R2", label: "Land & environment" },
  { key: "connectivity_evacuation", code: "R3", label: "Route & construction authorizations" },
  { key: "construction", code: "R4", label: "Electrical safety (build stage)" },
  { key: "pre_commissioning", code: "R5", label: "Pre-commissioning" },
  { key: "commissioning", code: "R6", label: "Commissioning & operations" },
];

// Page-level overrides (special notices etc.)
const APPROVAL_OVERRIDES = {
  ptcc: {
    notice: "Conditional — PTCC clearance was abolished by the Ministry of Power w.e.f. 01-Jul-2026 for new lines; CEA substitute coordination guidelines are awaited. Verify current applicability with the concerned authority before relying on this page.",
  },
};

module.exports = { STATES_SEO, GLOSSARY_SEO, CONDITION_LABELS, PROJECT_TYPE_LABELS, PHASES, APPROVAL_OVERRIDES };
